import * as React from "react";
import { Button } from "./externals";
export const PreviousNextButton = ({ onNextClick, onPreviousClick, className, style, minimal = false, }) => {
    return (React.createElement("div", { className: className, style: style },
        React.createElement(Button, { text: "Prev", onClick: onPreviousClick, name: "previous", icon: "arrow-left", "data-testid": "previousButton", minimal: minimal }),
        React.createElement(Button, { text: "Next", onClick: onNextClick, name: "next", rightIcon: "arrow-right", "data-testid": "nextButton", minimal: minimal })));
};
//# sourceMappingURL=PreviousNextButtons.js.map